import { createSelector } from '@ngrx/store';

import { createEntityCollectionStore, memoizeSelector } from '@core/ngrx-legacy';
import { sortByKey } from '@core/utils-legacy';

import { EntityStoreKey, TellentImpactTrackerData } from '../types';

const { actions, selectors, reducer, namespace } =
  createEntityCollectionStore<TellentImpactTrackerData>()(EntityStoreKey.TellentImpactTracker);

const byKind = memoizeSelector((kind: string) =>
  createSelector(selectors.entities(), function byKind(entities) {
    const entity = entities.find(entity => entity.kind === kind);
    if (!entity) return null;
    return {
      ...entity,
      insights: [...entity?.insights].sort(sortByKey('position', { direction: 'asc' })),
    };
  }),
);

const TellentImpactTrackerSelectors = { ...selectors, byKind };

export {
  actions as TellentImpactTrackerActions,
  TellentImpactTrackerSelectors,
  reducer as TellentImpactTrackerReducer,
  namespace as TellentImpactTrackerNamespace,
};
